import React from "react";
import { IActicityRootProps } from "./Activity.types";
import { StandadCard } from "../Cards";
import { Stack, Tab, Tabs } from "@mui/material";
import { a11yProps } from "../Tabs/utils";
import { TabPanel } from "../Tabs/TabPanel";
import { Activity } from "./Activity";
import { ActivityCommentsLogs } from "./CommentsLogs";
import { ActivityHistoryLogs } from "./ActivityHistory";
import { ActivityEmailConversationLogs } from "./ActivityEmailConversationLogs";
import { ActivitySMSLogs } from "./ActivitySMSLogs";
import { ActivityWhatsAppLogs } from "./ActivityWhatsAppLog";
import { ActivityInvoiceLogs } from "./ActivityInvoiceLogs";
import { ActivityComTabs } from "./ActivityComTabs";

export const ActivityRoot: React.FC<IActicityRootProps> = (props) => {
  const { activity, moduleInformation, disableTabs } = props;
  const [selectedTab, setSelectedTab] = React.useState(0);

    const handleTabChange = (event: React.SyntheticEvent, value: number) => {
    setSelectedTab(value);
  };

  const onTabChange = (value: number) => {
    window.scrollTo(0, 400);
    setSelectedTab(value);
  };


  // Build dynamic tabs array
  const tabsArr = [
    !disableTabs?.includes("ACTIVITIES") && {
      label: "Activities",
      key: "ACTIVITIES",
      content: activity ? (
        <Activity
          moduleInformation={moduleInformation}
          email={activity.email}
          task={activity.task}
          phoneWhatsAppSMS={activity.phoneWhatsAppSMS}
          changeTab={onTabChange}
        />
      ) : null,
    },
    !disableTabs?.includes("HISTORY") && {
      label: "History",
      key: "HISTORY",
      content: <ActivityHistoryLogs moduleInformation={moduleInformation} />,
    },
    !disableTabs?.includes("COMMENTS") &&
      activity &&
      !activity.disableComments && {
        label: "Comments",
        key: "COMMENTS",
        content: <ActivityCommentsLogs moduleInformation={moduleInformation} />,
      },
    !disableTabs?.includes("EMAIL_CONVERSATION") && {
      label: "Email Conversation",
      key: "EMAIL_CONVERSATION",
      content: (
        <ActivityEmailConversationLogs moduleInformation={moduleInformation} />
      ),
    },
    !disableTabs?.includes("SMS_CONVERSATION") && {
      label: "SMS Conversation",
      key: "SMS_CONVERSATION",
      content: <ActivitySMSLogs moduleInformation={moduleInformation} />,
    },
    !disableTabs?.includes("WHATSAPP_CONVERSATION") && {
      label: "WhatsApp Conversation",
      key: "WHATSAPP_CONVERSATION",
      content: <ActivityWhatsAppLogs moduleInformation={moduleInformation} phone={activity?.whatsAppChat?.phone || ""} customerName={activity?.whatsAppChat?.customerName || ""} />,
    },
    !disableTabs?.includes("INVOICING") &&
      activity &&
      activity.invoice && {
        label: "Invoicing",
        key: "INVOICING",
        content: (
          <ActivityInvoiceLogs
            moduleInformation={moduleInformation}
            customerId={activity.invoice.customerId}
          />
        ),
      },
  ].filter(Boolean); // Remove any false/null entries


  return (
    <StandadCard>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="scrollable"
        sx={{ mb: 2 }}
      >
        {tabsArr.map((tab: any, idx) => (
          <Tab
            key={tab.key}
            label={tab.label}
            sx={{ fontSize: "1.1rem", fontWeight: 600 }}
            {...a11yProps(idx)}
          />
        ))}
      </Tabs>
      {activity && (
        <Stack>
          <ActivityComTabs
            moduleInformation={moduleInformation}
            email={activity.email}
            task={activity.task}
            phoneWhatsAppSMS={activity.phoneWhatsAppSMS}
            changeTab={onTabChange}
          />
        </Stack>
      )}
      {tabsArr.map((tab: any, idx) => (
        <TabPanel key={tab.key} value={selectedTab} index={idx}>
          {tab.content}
        </TabPanel>
      ))}
    </StandadCard>
  );
};